import { UIPATH_COURSES } from './uipath/courses';
import { POWER_AUTOMATE_COURSES } from './power-automate/courses';
import { MULTI_PLATFORM_COURSES } from './multi-platform/courses';
import { SPECIALIZED_RPA_COURSES } from './specialized/courses';
import { Course } from '@/types/courseTypes';

// Convert RPA courses to match the expected Course interface
const convertRPACourse = (rpaCourse: any): Course => ({
  id: rpaCourse.id,
  title: rpaCourse.title,
  description: rpaCourse.description,
  level: rpaCourse.level,
  totalDuration: rpaCourse.duration || '8-10 hours',
  image: '/api/placeholder/400/300',
  prerequisites: rpaCourse.prerequisites || [],
  learningOutcomes: rpaCourse.learningObjectives || [],
  modules: rpaCourse.modules || [],
  type: 'rpa-tools'
});

export const RPA_COURSES: Course[] = [
  ...UIPATH_COURSES.map(convertRPACourse),
  ...POWER_AUTOMATE_COURSES.map(convertRPACourse),
  ...MULTI_PLATFORM_COURSES.map(convertRPACourse),
  ...SPECIALIZED_RPA_COURSES.map(convertRPACourse)
];